module.exports = __webpack_public_path__ + "public/SiteIcons/reservationFilter.svg?8983bc77";